/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import type { BvModalSectionSignature } from 'volta/components/bv-modal/section';

import templateOnly from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

export interface BvModalBodySignature {
  Args: {
    scrollable?: boolean;
    sectioned?: boolean;
    subdued?: boolean;
  };
  Blocks: {
    default: [props?: { Section: ComponentLike<BvModalSectionSignature> }];
  };
  Element: HTMLDivElement;
}

const BvModalBodyComponent = templateOnly<BvModalBodySignature>('BvModal::Body');

export default BvModalBodyComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Body': typeof BvModalBodyComponent;
    'bv-modal/body': typeof BvModalBodyComponent;
  }
}
